import React from 'react';

import GoogleMapReact from 'google-map-react';
import MapMarker from './MapMarker';

class MapWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
    };
  }

  componentDidMount() { }

  componentWillUnmount() { }
  onSelect = eventId => {
    this.setState({ selected: eventId });
  };
  render() {
    const hotel = this.props.hotel;
    const centerXY = {
      lat: hotel.position ? hotel.position.coordinates[1] : 30.267153,
      lng: hotel.position ? hotel.position.coordinates[0] : -97.7430608,
    };

    return (
      <div className="col-sm-12 col-md-12" style={{ height: 600 }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyC_dfJjkQ_rwR1TLJ1ZKWUZcttrzDypBJ0' }}
          defaultZoom={15}
          center={centerXY}
        >
          <MapMarker
            key={hotel.id}
            hotel={hotel}
            lat={hotel.position ? hotel.position.coordinates[1] : 30.267153}
            lng={hotel.position ? hotel.position.coordinates[0] : -97.7430608}
            selected={false}
            onSelect={() => { }}
          />
        </GoogleMapReact>
      </div>
    );
  }
}
export default MapWidget;


// WEBPACK FOOTER //
// src/routes/hotels/components/MapWidget.js